export class NotTeacherAccountError extends Error {
  constructor() {
    super(`The account is not a teacher account`);
  }
}
